import { BILL_ADJUSTMENT_REQUEST, GET_BILL_ADJUSTMENTS, SET_BILL_ADJUSTMENTS, BILL_ADJUSTMENT_REQUEST_FAILURE, RESET_BILL_ADJUSTMENTS } from '../types';

const initialState = {
  billAdjustments: [],
  loading: false,
  error: null,
  page: 1,
  limit: 10,
  totalRecords: 0,
  totalPages: 0,
};

const billAdjustmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case BILL_ADJUSTMENT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BILL_ADJUSTMENTS: {
      const { page, limit, totalRecords, totalPages, data } = action.payload;
      return {
        ...state,
        billAdjustments: page === 1 ? data : [...state.billAdjustments, ...data],
        page,
        limit,
        totalRecords,
        totalPages,
        loading: false,
        error: null
      }
    }
    case SET_BILL_ADJUSTMENTS: {
      return {
        ...state,
        billAdjustments: action.payload,
      }
    }
    case RESET_BILL_ADJUSTMENTS:
      return {
        ...state,
        billAdjustments: [],
        page: 1,
        limit: 10,
        totalRecords: 0,
        totalPages: 0,
        loading: false,
        error: null
      };  
    case BILL_ADJUSTMENT_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default billAdjustmentReducer;